export type SimulationAmortissementWidgetViewState =
  | "idle"
  | "submitting"
  | "success"
  | "error";

export const SIMULATION_AMORTISSEMENT_FORM_STEPS = [
  "intro",
  "bien",
  "contact",
  "result",
  "expert-optin",
] as const;

export type SimulationAmortissementFormStep =
  (typeof SIMULATION_AMORTISSEMENT_FORM_STEPS)[number];

export type SimulationAmortissementSlugParameter = "france" | "paris";

export interface SimulationAmortissementPosteModel {
  libelle: string;
  base_calcul: string;
  taux: number;
  duree: number;
  montant_base: number;
  montant_annuel: number;
  montant_mensuel: number;
}

export interface SimulationAmortissementResultModel {
  amortissement_annuel: number;
  amortissement_mensuel: number;
  postes: SimulationAmortissementPosteModel[];
}

export interface SimulationAmortissementFormModel {
  email: string;
  firstName: string;
  source: string;
  consent: boolean;
  slugParameter: SimulationAmortissementSlugParameter;
  prixAchat: string;
  travaux: string;
  ameublement: string;
  expertComptable: boolean;
  courtier: boolean;
  chasseurImmobilier: boolean;
  honeypot: string;
}

export function getInitialSimulationAmortissementFormStep(): SimulationAmortissementFormStep {
  return SIMULATION_AMORTISSEMENT_FORM_STEPS[0];
}

export function getNextSimulationAmortissementFormStep(
  currentStep: SimulationAmortissementFormStep,
): SimulationAmortissementFormStep {
  switch (currentStep) {
    case "intro":
      return "bien";
    case "bien":
      return "contact";
    case "contact":
      return "result";
    case "result":
      return "expert-optin";
    case "expert-optin":
      return "expert-optin";
    default:
      return currentStep;
  }
}

export function getPreviousSimulationAmortissementFormStep(
  currentStep: SimulationAmortissementFormStep,
): SimulationAmortissementFormStep {
  switch (currentStep) {
    case "bien":
      return "intro";
    case "contact":
      return "bien";
    case "result":
      return "contact";
    case "expert-optin":
      return "result";
    default:
      return currentStep;
  }
}

export function getSimulationAmortissementFormProgress(
  currentStep: SimulationAmortissementFormStep,
): { current: number; total: number } {
  switch (currentStep) {
    case "intro":
      return { current: 0, total: 3 };
    case "bien":
      return { current: 1, total: 3 };
    case "contact":
      return { current: 2, total: 3 };
    case "result":
      return { current: 3, total: 3 };
    case "expert-optin":
      return { current: 3, total: 3 };
    default:
      return { current: 0, total: 3 };
  }
}
